import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";

var styles = {
  groupSection: {
    color: colors.neutral[900],
    paddingBottom: '1.5rem',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300])
  },
  groupName: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    textTransform: 'capitalize',
    letterSpacing: '0.02em',
    margin: 0,
    marginBottom: '1rem'
  },
  groupInfo: {
    fontSize: '1.4rem',
    margin: 0,
    '& b': {
      marginRight: '1rem'
    },
    '&:not(:last-child)': {
      marginBottom: '1rem'
    }
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map